<template>
  <div>
    <ul class="mt-8">
      <li v-for="(cabin, index) in cabins" :key="cabin.id">
        <hr class="border border-black-30 my-8 sm:hidden">
        <div class="flex sm:flex-wrap resort-room sm:mt-8">
          <div class="flex-1 sm:w-full resort-room-image">
            <div class="aspect-ratio-20/13 h-full">
              <div>
                <cabin-image-carousel :images="cabin.images" />
              </div>
            </div>
          </div>
          <div class="flex-1 p-6 flex flex-col sm:px-0 sm:pb-0 sm:pt-4">
            <h4 class="fs-20 font-bold font-bry">{{ cabin.name }}</h4>
            <p class="mt-1 sm:mt-0">{{ cabin.desc }}</p>

            <div class="text-black-light-5 mt-4 sm:mt-2">
              {{ getInclusionsDisplay(cabin) }}
            </div>

            <div class="flex-1">
              <div class="text-secondary font-medium cursor-pointer mt-2 sm:mt-1 lh-100"
                @click="handleRoomDetailsClicked(cabin)">
                View cabin amenities
              </div>
            </div>
          </div>
        </div>
        <hr class="border border-black-30 my-8 sm:hidden" v-if="index + 1 === cabins.length">
      </li>
    </ul>

    <zb-modal ref="roomDetailsModal" class="slide-in-modal">
      <h2 slot="title" class="fs-20 font-medium mb-6">Cabin amenities</h2>

      <template>
        <div v-if="viewingCabin">
          <template v-if="included.length">
            <h5 class="font-medium my-3" v-if="included.length">Included</h5>
            <inclusion-sub-list :inclusions="included" />
          </template>

          <template v-if="notIncluded.length">
            <hr class="border border-black-30 my-6">
            <h5 class="font-medium my-3">Not Included</h5>
            <inclusion-sub-list :inclusions="notIncluded" />
          </template>

          <template v-if="extra.length">
            <hr class="border border-black-30 my-6">
            <h5 class="font-medium my-3">Additional cost</h5>
            <inclusion-sub-list :inclusions="extra" />
          </template>
        </div>
      </template>
    </zb-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import get from 'lodash/get'

import InclusionSubList from '../../components/core/InclusionSubList'
import CabinImageCarousel from './../liveaboard/CabinImageCarousel'

export default {
  components: {
    InclusionSubList,
    CabinImageCarousel,
  },
  data () {
    return {
      viewingCabin: null
    }
  },
  computed: {
    ...mapState(['supplier']),
    cabins() {
      return get(this.supplier, 'rooms', [])
    },
    included () {
      return this.viewingCabin.inclusions.filter(incl => incl.type === 'included')
    },
    extra () {
      return this.viewingCabin.inclusions.filter(incl => incl.type === 'extra')
    },
    notIncluded () {
      return this.viewingCabin.inclusions.filter(incl => incl.type === 'not_included')
    }
  },
  methods: {
    getInclusionsDisplay (cabin) {
      const incls = cabin.inclusions.slice(0, 3).map(incl => incl.name)

      return incls.join(', ') + (cabin.inclusions.length > 3 ? '...' : '')
    },
    handleRoomDetailsClicked (cabin) {
      this.viewingCabin = cabin
      this.$refs.roomDetailsModal.show()
    }
  }
}
</script>
